import { CorporateFareOutlined, PersonOutline, ShoppingBagOutlined } from '@mui/icons-material';

import { USER_ROLES } from '@constants';
import { BRIGHTPATH_ADMIN_URL, EMPLOYERS_URL } from '@constants/externalRoutes';

import EmployersSvg from '@images/employers.svg?react';

import { RoleSpecificNav } from './types';

export const NAVIGATION_ITEMS: RoleSpecificNav[] = [
  {
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.STAFF],
    icon: <PersonOutline fontSize='large' sx={{ height: '1.5rem', width: '1.5rem' }} />,
    key: 'users',
    path: `${BRIGHTPATH_ADMIN_URL}/users`,
    title: 'Users',
    translateKey: 'Users',
  },
  {
    allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.STAFF],
    icon: <CorporateFareOutlined fontSize='large' sx={{ height: '1.5rem', width: '1.5rem' }} />,
    key: 'organizations',
    path: `${BRIGHTPATH_ADMIN_URL}/organizations`,
    title: 'Organizations',
    translateKey: 'Organizations',
  },
  {
    allowedRoles: [USER_ROLES.ADMIN],
    icon: <EmployersSvg style={{ height: '1.5rem', width: '1.5rem' }} />,
    key: 'employers',
    path: `${EMPLOYERS_URL}/micro/admin/employers`,
    restrictOrg: true,
    title: 'Employers',
    translateKey: 'Employers',
  },
  {
    allowedRoles: [USER_ROLES.ADMIN],
    icon: <ShoppingBagOutlined fontSize='large' sx={{ height: '1.5rem', width: '1.5rem' }} />,
    key: 'd2c',
    path: `${BRIGHTPATH_ADMIN_URL}/d2c`,
    restrictOrg: true,
    title: 'DTC Purchases',
    translateKey: 'DTC Purchases',
  },
];

export const ROLE_SPECIFIC_ROUTES: RoleSpecificNav[] = [
  {
    allowedRoles: [USER_ROLES.ADMIN],
    icon: <EmployersSvg style={{ height: '1.5rem', width: '1.5rem' }} />,
    key: 'employers',
    path: `${EMPLOYERS_URL}m/micro/admin/employers`,
    restrictOrg: true,
    title: 'Employers',
    translateKey: 'Employers',
  },
];
